export const listingsGridStyles = {
  container: "space-y-4",
  
  autoRefreshIndicator: "flex items-center justify-center bg-blue-50 text-blue-700 px-4 py-2 rounded-md",
  
  loadingContainer: "flex flex-col items-center justify-center py-12",
  loadingSpinner: "animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-[#96ffa8] mb-4",
  loadingText: "text-gray-600",
  
  tableContainer: "bg-[#ffffff] overflow-hidden shadow-lg border border-[#96ffa8] rounded-lg",
  tableHeader: "bg-[#e6ffea]",
  tableHeaderCell: "px-4 py-4 text-left text-xs font-medium text-black uppercase tracking-wider cursor-pointer",
  
  expandedRow: "bg-[#f0fff3] border-t border-[#d7f5df]",
  expandedRowContent: "px-6 py-4",
  
  actionButtonsContainer: "flex flex-wrap gap-2 mb-4 pb-4 border-b border-[#d7f5df]",
  
  cardGrid: "grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6 w-full",
  card: "bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow",
  cardHeader: "flex items-center mb-4",
  cardIcon: "w-8 h-8 rounded-lg flex items-center justify-center mr-3",
  cardTitle: "text-lg font-semibold text-gray-900",
  
  emptyState: "px-6 py-8 text-center text-gray-500 bg-[#f0fff3]",
  emptyStateIcon: "mx-auto h-12 w-12 text-[#96ffa8]",
  
  paginationContainer: "bg-[#f0fff3] px-4 py-3 border-t border-[#d7f5df] flex items-center justify-between"
};